import React, { FC, RefObject, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import icons from '../../../../icons';
import { LeftPaneContext } from "../LeftPaneContext";
import { ContextMenu } from "../../../../components/ContextMenu";
import { Sequence } from '@vse/machinelogic/types';

export interface SequenceContextMenuProps {
  sequence: Sequence;
  toggleTextInput: () => void;
  scrollingContainerRef: RefObject<HTMLDivElement>;
}

export const SequenceContextMenu: FC<SequenceContextMenuProps> = observer(({sequence, toggleTextInput, scrollingContainerRef}) => {
  const { library, showConfirmationModal, openSequence, isRunning } = useContext(LeftPaneContext);
  const application = sequence.getApp();

  const menuItems = [
    {
      text: 'Rename',
      icon: icons.edit,
      onClick: () => toggleTextInput()
    },
    {
      text: 'Duplicate',
      icon: icons.copy,
      onClick: () => {
        const sequenceData = sequence.toJson();
        sequenceData.name += ' Copy';
        const newSequence = application.addSequence(sequenceData);
        application.selectSequenceByName(newSequence.name);

        const originalSequenceIndex = application.sequences.indexOf(sequence);
        const newSequenceIndex = application.sequences.indexOf(newSequence);
        application.moveSequence(newSequenceIndex, originalSequenceIndex + 1);

        openSequence(library, application, newSequence);
      }
    },
    {
      text: 'Create New',
      icon: icons.add_application,
      onClick: () => {
        const newSequence = application.newSequence();
        application.selectSequenceByName(newSequence.name);
        openSequence(library, application, newSequence);
      }
    },
    {
      text: 'Delete',
      icon: icons.removeCard,
      className: 'delete',
      disabled: sequence.isInitialSequence(),
      onClick: () => {
        const dependantSequencesCount = library.validator.instructionsUsingSequence(sequence.name, application).length;
        if (dependantSequencesCount == 0) {
          application.removeSequence(sequence.name);
          application.selectSequenceByName(application.initialSequence.name);
          openSequence(library, application, application.initialSequence);
        } else {
          const plural = dependantSequencesCount > 1 ? 's' : '';
          showConfirmationModal(
            'Delete Child Sequence',
            `This action will result in ${ dependantSequencesCount } invalid MachineLogic command${ plural }.`,
            () => {
              application.removeSequence(sequence.name);
              application.selectSequenceByName(application.initialSequence.name);
              openSequence(library, application, application.initialSequence);
            });
        }
      }
    },
  ];

  return (
    <ContextMenu menuItems={menuItems} scrollingContainerRef={scrollingContainerRef} disabled={isRunning || library.currentApplication.isReadOnly()} />
  );
});